module.exports = __webpack_public_path__ + "img/mat_409.8387524d.png";